var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6493 8.61739C8.0932 5.81053 12.3891 3.95989 14.537 3.06583C20.6771 0.512783 21.9513 0.0693777 22.7835 0.0545284C22.9666 0.0514204 23.3741 0.0966586 23.64 0.311801C23.861 0.4931 23.9232 0.738286 23.9543 0.910261C23.9819 1.08224 24.0199 1.47419 23.9888 1.78015C23.6573 5.27492 22.2173 13.7556 21.4852 17.6699C21.1778 19.3262 20.5665 19.8815 19.976 19.9357C18.6914 20.0538 17.7175 19.0876 16.4743 18.2729C14.5301 16.9976 13.432 16.204 11.543 14.9598C9.36054 13.5218 10.7764 12.7313 12.0196 11.4398C12.3442 11.1017 18.0007 5.95799 18.1077 5.49144C18.1215 5.43308 18.1354 5.21552 18.0042 5.10087C17.8764 4.98588 17.6864 5.02524 17.5482 5.05632C17.3514 5.10053 14.2469 7.15456 8.22427 11.2181C7.34367 11.8238 6.54598 12.1191 5.82768 12.1035C5.04033 12.0866 3.52096 11.6574 2.39173 11.2906C1.0104 10.8406 -0.0912681 10.6027 0.00542497 9.83849C0.0537715 9.44067 0.602938 9.03352 1.6493 8.61739Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/TelegramIcon.f44a559eced16f4e4027c29550fc58e8.svg";
export { ForwardRef as ReactComponent };